import type {User} from "~/types/user";
import type {Role, TeamUser} from "~/types/team-user-invite";

export const useProducerSessionAdm = () => {
  const config = { path: '/', watch: true };
  const user = useCookie<User | null>('sr-user', config)
  const userAdmId = useCookie('user-session-team-adm-id', config)
  const userAdmName = useCookie('user-session-team-adm-name', config)
  const { getAllTeamUser } = useTeamUserInvite()

  const { data: teamUser, refresh } = useAsyncData(
    () => 'team-user-list-' + user.value?.id,
    () => getAllTeamUser(),
    {
      lazy: false,
      // @ts-ignore
      staleTime: 60 * 1000, // ✅ Cache de 60 segundos
      server: true
    }
  )

  watchEffect(() => {
    if (!userAdmId.value && user.value?.id){
      userAdmId.value = user.value.id
    }
  })

  const userAdmIdModel = computed({
    get: () => userAdmId.value || '',
    set: async (value: string) => {
      userAdmId.value = value
      if (!teamUser.value) {
        await refresh()
      }

      const selectedTeamUser = teamUser.value?.find((r: TeamUser) => r.admId === value)
      if (selectedTeamUser?.name) {
        userAdmName.value = selectedTeamUser.name
      } else if (value === user.value?.id) {
        userAdmName.value = user.value?.name || ''
      }
    }
  })

  const userAdmNameModel = computed({
    get: () => userAdmName.value || '',
    set: (value: string) => {
      userAdmName.value = value
    }
  })

  const role = computed((): Role | undefined => {
    if (user.value?.id === userAdmIdModel.value) return 'OWNER'
    return teamUser.value?.find((r: TeamUser) => r.admId === userAdmIdModel.value)?.role
  })

  const setUserAdm = (id: string, name: string): void => {
    userAdmId.value = id
    userAdmName.value = name
  }

  return {
    setUserAdm,
    userAdmName: userAdmNameModel,
    userAdmId: userAdmIdModel,
    role,
    teamUser
  }
}
